import { createStore } from 'vuex'
import auth from './modules/auth'
// import spacesWx from './modules/spacesWx'
// import spacesWebWx from './modules/spacesWebWx'
// import foldersWx from './modules/foldersWx'
// import pages from './modules/pages'
// import aiInternet from './modules/aiInternet'
import wechatAuth from './modules/wechatAuth'
// import wechatDrive from './modules/wechatDrive'
// import wechatMessage from './modules/wechatMessage'
// import filesWx from './modules/filesWx'
// import filesWebWx from './modules/filesWebWx'
// import arcApi from './modules/arc'
// import actions from './modules/actions'
// import alert from './modules/alertWx'
// import financePerformance from './modules/financePerformanceWx'
// import financePerformanceWebWx from './modules/financePerformanceWebWx'
// import financePerformanceChannelWebWx from './modules/financePerformanceChannelWebWx'
// import productPerformance from './modules/productPerformanceWx'
// import productPerformanceWebWx from './modules/productPerformanceWebWx'
// import productPerformanceChannelWebWx from './modules/productPerformanceChannelWebWx'
// import productPerformanceChannelScmWebWx from './modules/productPerformanceChannelScmWebWx'
// import approval from './modules/approvalWx'
// import approvalWebWx from './modules/approvalWebWx'
// import messageWx from './modules/messageWx'
import funnelWx from './modules/funnelWx'
import divisionOrgSalesWx from './modules/divisionOrgSalesWx'
import divisionOrgSalesWebWx from './modules/divisionOrgSalesWebWx'
// import alertWebWx from './modules/alertWebWx'
// import actionWebWx from './modules/actionWebWx'
// import messageWebWx from './modules/messageWebWx'
import funnelWebWx from './modules/funnelWebWx'
// import skuForecastWebWx from './modules/skuForecastWebWx'
// import skuForecastWx from './modules/skuForecastWx'

export default createStore({
  state: {
    appName: 'DigitalHub',
    appVersion: '1.0.0',
    sidebarCollapsed: false,
    darkMode: localStorage.getItem('darkMode') === 'true',
    notifications: []
  },
  
  getters: {
    appName: state => state.appName,
    appVersion: state => state.appVersion,
    isSidebarCollapsed: state => state.sidebarCollapsed,
    isDarkMode: state => state.darkMode,
    notifications: state => state.notifications
  },
  
  mutations: {
    toggleSidebar(state) {
      state.sidebarCollapsed = !state.sidebarCollapsed
    },
    
    setSidebarState(state, collapsed) {
      state.sidebarCollapsed = collapsed
    },
    
    toggleDarkMode(state) {
      state.darkMode = !state.darkMode
      localStorage.setItem('darkMode', state.darkMode)
      
      // 应用暗黑模式
      if (state.darkMode) {
        document.documentElement.classList.add('dark-mode')
      } else {
        document.documentElement.classList.remove('dark-mode')
      }
    },
    
    addNotification(state, notification) {
      state.notifications.push({
        id: Date.now(),
        read: false,
        timestamp: new Date(),
        ...notification
      })
    },
    
    markNotificationAsRead(state, notificationId) {
      const notification = state.notifications.find(n => n.id === notificationId)
      if (notification) {
        notification.read = true
      }
    },
    
    clearNotifications(state) {
      state.notifications = []
    }
  },
  
  actions: {
    initApp({ commit, state }) {
      // 初始化应用时应用暗黑模式设置
      if (state.darkMode) {
        document.documentElement.classList.add('dark-mode')
      }
    },
    
    addNotification({ commit }, notification) {
      commit('addNotification', notification)
      
      // 如果设置了自动关闭
      if (notification.autoClose !== false) {
        const timeout = notification.timeout || 5000
        setTimeout(() => {
          commit('markNotificationAsRead', notification.id)
        }, timeout)
      }
    }
  },
  
  modules: {
    auth,
    // spacesWx,
    // spacesWebWx,
    // foldersWx,
    // pages,
    // aiInternet,
    wechatAuth,
    // wechatDrive,
    // wechatMessage,
    // filesWx,
    // filesWebWx,
    // arcApi,
    // actions,
    // alert,
    // financePerformance,
    // financePerformanceWebWx,
    // financePerformanceChannelWebWx,
    // productPerformance,
    // productPerformanceWebWx,
    // productPerformanceChannelWebWx,
    // productPerformanceChannelScmWebWx,
    // approval,
    // approvalWebWx,
    // messageWx,
    funnelWx,
    divisionOrgSalesWx,
    // alertWebWx,
    // actionWebWx,
    // messageWebWx,
    funnelWebWx,
    // skuForecastWebWx,
    // skuForecastWx,
    divisionOrgSalesWebWx
  }
})